export type OpenDrawer = 'left' | 'right' | 'none'

export enum LeftDrawerContent {
  Default = 'default',
  ReportGraphs = 'report-graphs',
}

export enum RightDrawerContent {
  AuditLog = 'audit-log',
  Communication = 'communication',
  FileAttachments = 'file-attachments',
  FilePreview = 'file-preview',
  TPSuggestions = 'tp-suggestions',
  InsightsProperties = 'insights-properties',
  TalkingPoints = 'talking-points',
  InsightsAccountsList = 'insights-accounts-list',
  InsightsAssistant = 'insights-assistant',
  AiChat = 'ai-chat',
}

export type DrawerPosition = Exclude<OpenDrawer, 'none'>

export type MainDrawerState =
  | {
      direction: 'left'
      content: LeftDrawerContent
    }
  | {
      direction: 'right'
      content: RightDrawerContent
    }

export type DrawerState =
  | MainDrawerState
  | {
      direction: 'initial'
      content: ''
    }
  | {
      direction: 'none'
      content: 'default'
    }

export type PersistableRightDrawerContent =
  | RightDrawerContent.AuditLog
  | RightDrawerContent.Communication
  | null

export const PERSISTABLE_RIGHT_DRAWER_CONTENTS: ReadonlyArray<RightDrawerContent | null> =
  [null, RightDrawerContent.AuditLog, RightDrawerContent.Communication]
